import { render, staticRenderFns } from "./VesselSpecification.vue?vue&type=template&id=813d2326&scoped=true&"
import script from "./VesselSpecification.vue?vue&type=script&lang=js&"
export * from "./VesselSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813d2326",
  null
  
)

export default component.exports